import styled from "styled-components";

export const Page = styled.div`
    background-color: #f8fafb;
    font-family: 'Montserrat', sans-serif;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
      width: 100%;
    }
`

export const TopNav = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: linear-gradient(135deg, #0a1e3d 0%, #1a3a5c 100%);
    box-shadow: 0 2px 8px rgba(10, 30, 61, 0.15);
    position: sticky;
    top: 0;
    z-index: 1000;
    border-bottom: 2px solid #ff8c42;
`

export const NavBar = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 2rem;
    gap: 1.5rem;
    width: 95%;

    @media (max-width: 1024px) {
      padding: 0.75rem 1.5rem;
      gap: 1rem;
    }

    @media (max-width: 768px) {
      padding: 0.75rem 1rem;
      gap: 0.75rem;
      flex-wrap: wrap;
    }
`

export const NavLogoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.8;
    }

    @media (max-width: 768px) {
      gap: 0.5rem;
    }
`

export const NavBrand = styled.span`
    font-size: 1.25rem;
    font-weight: 700;
    color: white;
    letter-spacing: 0.5px;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
`

export const NavMenuSection = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 1;
    justify-content: center;

    @media (max-width: 768px) {
      flex: 1;
      width: 100%;
      justify-content: flex-start;
      order: 3;
    }
`

export const NavActionsSection = styled.div`
    display: flex;
    align-items: center;
    gap: 1.5rem;
    flex-shrink: 0;

    @media (max-width: 768px) {
      gap: 1rem;
    }
`

export const NavUser = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    background-color: rgba(255, 255, 255, 0.1);

    @media (max-width: 768px) {
      gap: 0.5rem;
      padding: 0.4rem 0.6rem;
    }
`

export const NavUserName = styled.span`
    color: white;
    font-size: 0.9rem;
    font-weight: 500;

    @media (max-width: 768px) {
      font-size: 0.8rem;
      display: none;
    }
`

export const NavNotification = styled.div<{ count: number }>`
    width: 1.25rem;
    height: 1.25rem;
    background: url(${props => props.count === 0 ? '/images/bell.svg' : '/images/notification.svg'});
    background-repeat: no-repeat;
    background-size: 1.25rem 1.25rem;
    cursor: pointer;
    filter: brightness(2);

    @media (max-width: 768px) {
      width: 1rem;
      height: 1rem;
      background-size: 1rem 1rem;
    }
`

export const NavUserProfile = styled.div<{ profileImage?: string }>`
    width: 2rem;
    height: 2rem;
    background: url(${props => props.profileImage ?? '/images/profile.svg'});
    background-repeat: no-repeat;
    background-size: 2rem 2rem;
    background-position: center;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid rgba(255, 255, 255, 0.3);
    transition: all 0.2s ease;

    &:hover {
      border-color: rgba(255, 255, 255, 0.6);
      box-shadow: 0 0 8px rgba(255, 140, 66, 0.5);
    }

    @media (max-width: 768px) {
      width: 1.75rem;
      height: 1.75rem;
      background-size: 1.75rem 1.75rem;
    }
`

export const NavLogout = styled.button`
    width: 2.3rem;
    height: 2.3rem;
    background: url('/images/logout.svg');
    background-repeat: no-repeat;
    background-size: 2.3rem 2.3rem;
    background-position: center;
    border: none;
    cursor: pointer;
    opacity: 0.8;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
      opacity: 1;
      filter: drop-shadow(0 0 4px rgba(255, 140, 66, 0.5));
    }

    @media (max-width: 768px) {
      width: 2rem;
      height: 2rem;
      background-size: 2rem 2rem;
    }
`

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 2rem;
    background: linear-gradient(90deg, #ffffff 0%, #f8fafb 100%);
    border-bottom: 1px solid #e8ecf1;

    @media (max-width: 1024px) {
      padding: 0.5rem 1.5rem;
    }

    @media (max-width: 768px) {
      padding: 0.5rem 1rem;
    }
`

export const Breadcrumb = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5rem 0;
    gap: 0.625rem;
    color: #0a1e3d;
    font-size: 0.9rem;

    @media (max-width: 768px) {
      font-size: 0.8rem;
      padding: 0.4rem 0;
    }
`

export const Children = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    min-height: calc(100vh - 8rem);
    overflow-y: auto;
    flex: 1;

    @media (max-width: 768px) {
      min-height: calc(100vh - 6rem);
    }
`

export const HomeIconContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: #ff8c42;
    }
`

export const HighLightButton = styled.div`
    background-color: rgba(255, 140, 66, 0.2);
    border-radius: 0.5rem;
    border-left: 3px solid #ff8c42;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    width: 2rem;
    flex-shrink: 0;

    @media (max-width: 768px) {
      height: 1.75rem;
      width: 1.75rem;
      font-size: 1.2rem;
    }
`

export const Element = styled.div``

export const HighLightContainer = styled.div``
